@if(this.displayLogo){
    <ion-avatar 
        class="logo_retailer"
        [class.big]="this.sizeLogo === 'big'"
        [class.small]="this.sizeLogo === 'small'"
        [class.with_margin_right]="this.withMarginRight"
        >
        <img 
            [src]="this.retailerLogo.logo" 
            [alt]="this.retailerLogo.retailer" 
            [title]="this.retailerLogo.retailer" 
            (error)="this.onImgError($event)"
            />
    </ion-avatar>
}